module.exports = __webpack_public_path__ + "static/media/balancer.85de4108.svg";